import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const ResultsBlock = ({ listResults }) => {
    return (
        <FullWrapper className="results">
            <div className="results-block">
                <div className="results-block__title">Результаты</div>
                <div className="results-block__description">
                    Нам удалось собрать большой информационный трафик и&nbsp;конвертировать его
                    в&nbsp;заказы на&nbsp;сайте. За&nbsp;год (февраль 2022&nbsp;&mdash; январь 2023)
                    мы&nbsp;опубликовали 12&nbsp;статей. Количество уникальных посетителей
                    и&nbsp;визитов на&nbsp;сайт выросло в&nbsp;4&nbsp;раза по&nbsp;сравнению
                    с&nbsp;2021&nbsp;годом. Уникальность и&nbsp;качество контента&nbsp;&mdash;
                    главный показатель, влияющий на&nbsp;такой результат. Всё сделано без закупки
                    ссылок.
                </div>
                <div className="results-block__item">
                    {listResults.map((item, idx) => (
                        <div key={idx} className="results-block-info">
                            <div className="results-block-info__top">
                                <div className="results-block-info__top-text">{item.text}</div>
                                <img
                                    src={item.icon}
                                    alt="statistic-icon"
                                    className="results-block-info__top-icon"
                                />
                            </div>
                            <div className="results-block-info__bottom">
                                <div className="results-block-info__bottom-number">
                                    {item.number}
                                </div>
                                <div className="results-block-info__bottom-percent">
                                    {item.percent}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="results-block__graphic">
                    <div className="results-block__graphic-subtitle">
                        Переходы из&nbsp;поисковых систем (февраль 2022&nbsp;&mdash; январь 2023)
                    </div>
                    <div className="results-block__graphic-block">
                        <div className="results-block__graphic-header">100 000</div>
                        <div className="results-block__graphic-start">20 000</div>
                        <img
                            src="/images/svg/new-medved/results-graphic.svg"
                            alt="results-block-graphic"
                            className="results-block__graphic-middle"
                        />
                        <div className="results-block__graphic-bottom">
                            <div className="results-block__graphic-month">февраль 2022</div>
                            <div className="results-block__graphic-month">январь 2023</div>
                        </div>
                    </div>
                    <div className="results-block__graphic-text">
                        Контентное решение позволило нашему клиенту не&nbsp;только вернуть
                        показатели трафика &laquo;до&nbsp;эры маркетплейсов&raquo;,
                        но&nbsp;и&nbsp;значительно их&nbsp;превзойти. Полезный SEO-текст стал
                        продавцом, который убеждает и&nbsp;подталкивает к&nbsp;покупке.
                    </div>
                </div>
            </div>
        </FullWrapper>
    );
};
export default ResultsBlock;
